<script>

	import { link }   from "svelte-routing";
	import { createEventDispatcher, afterUpdate } from 'svelte';
	import { 
		linkFacebook,
		linkInstagram,
		linkTwitter,
		linkWhatsappVendas,
		linkWhatsappLocacao,
		linkAV,
		alt
	 } from '../store.js';

	// Componentes
	import HeaderItem           from './Header__Item.svelte';
	
	// Code
	export let classe           = "";
	export let logo 		    = "/assets/images/logotipo.png";
	export let logoHeight       = "65px";
	export let logoWidth        = "auto"
	export let style            = "";

	export let menu             = [];			
	export let menuSecondary     = [];

	let social = [
		{
			title: 'Facebook',
			icon: '<i class="fab fa-2x fa-facebook-f"></i>',
			link: $linkFacebook,
			target: '_blank',
		},
		{
			title: 'Instagram',
			icon: '<i class="fab fa-2x fa-instagram"></i>',
			link: $linkInstagram,
			target: '_blank',
		},
		{
			title: 'Twitter',
			icon: '<i class="fab fa-2x fa-twitter"></i>',
			link: $linkTwitter,
			target: '_blank',
		}
		/*,
		{
			title: 'Whatsapp',
			icon: '<i class="fab fa-2x fa-whatsapp"></i>',
			link: $linkWhatsappVendas,
			target: '_blank',
		}
		*/
	];
</script>

<header class="header header--{style} {classe}">
	<div class="container">
		<nav class="navbar-expand-lg navbar">
			<a class="logo navbar-brand" href="/home" use:link replace title="Ir para Home">
				<img class="img-fluid" src="{logo}" alt="Logo{$alt}" width="{logoWidth}" style="max-height: {logoHeight};">
			</a>
			<button class="navbar-toggler" data-toggle="collapse" data-target=".navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Alterna navegação">
				<div class="navbar-toggler-icon">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</div>
			</button>
			<div class="navbar-collapse collapse justify-content-end">
				<ul class="navbar-nav menu">
					{#each menu as item}
						<HeaderItem {...item} />
					{/each}
				</ul>
			</div>
		</nav>
	</div>
</header>
<div class="hidden-xl hidden-lg background-primary p-5">
	<a href={$linkAV} target="_blank" class="btn btn-primary btn-lg btn-block">Área do Cliente</a>
</div>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

/* Header */
header 
	.navbar 
		padding: 0
		.logo
			padding: 5px 0
		.menu 
			align-items: center     

.header--double
	.navbar-collapse
		+transition(all 0.5s)
		padding: 0
		flex-direction: column
		align-items: flex-end
		margin: 0
		padding: 10px
		.menu--bottom
			border-top: 1px solid #f1f1f1
			+media-breakpoint-up(lg)	
				margin-top: 10px
				padding-top: 10px

/* Menu Mobile */
.navbar-toggler
	.navbar-toggler-icon
		position: relative
		span
			background-color: #1562a6
			display: block
			height: 3px
			position: absolute
			transform-origin: center
			transition-duration: 86ms
			transition-property: background-color,opacity,transform
			transition-timing-function: ease-out
			width: 25px
			&:nth-child(1)
				top: calc(50% - 10px)
			&:nth-child(2)
				top: calc(50% - 1px)
			&:nth-child(3)
				top: calc(50% + 8px)
	&[aria-expanded="true"]
		.navbar-toggler-icon span
			&:nth-child(1)
				transform: translateY(10px) rotate(45deg)
			&:nth-child(2)
				opacity: 0
			&:nth-child(3)
				transform: translateY(-8px) rotate(-45deg)
</style>